'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'

export function PostHogPageview() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      // LUL-7231 (O9): Orders pageviews don't send the query string (filters,
      // company, cursor; the search itself never goes into the page URL). Only
      // this $pageview is covered: $pageleave / $exception would still carry
      // the full URL if client PostHog were turned on. Site-wide: LUL-7218.
      const orders = pathname === '/commerce/orders' || pathname.startsWith('/commerce/orders/')
      if (searchParams.toString() && !orders) {
        url = url + '?' + searchParams.toString()
      }
      posthog.capture('$pageview', { $current_url: url })
    }
  }, [pathname, searchParams, posthog])

  return null
}
